module.exports = __webpack_public_path__ + "img/sv76.e102b116.svg";